import { render, staticRenderFns } from "./CgShopManage.vue?vue&type=template&id=5b352ac4&scoped=true"
import script from "./CgShopManage.vue?vue&type=script&lang=js"
export * from "./CgShopManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b352ac4",
  null
  
)

export default component.exports